import { getAccountAccessLevel, getGeneralInfo } from '@/store/account/actions';
import { AccessLevel, ProductType } from '@dev/ee-api/ee-api-models';
import { useSelector } from 'react-redux';
import { useCurrentPlanStatus } from './useCurrentPlanStatus';

type PlanHaveRecaptchaFeatureType = {
    ViewSubscriptionAntiSpamFeature: boolean;
    ViewAntiSpamUpsellingBanner: boolean;
};

export const usePlanHaveRecaptchaFeature = (): PlanHaveRecaptchaFeatureType => {
    const { IsPro, ProductType: productType } = useSelector(getGeneralInfo);
    const accountAl = useSelector(getAccountAccessLevel);
    const { isStandardPlan } = useCurrentPlanStatus();
    const isSubscriptionAntiSpam = accountAl?.includes(AccessLevel.ModifySubscriptionAntiSpam);
    const isCreatorProduct = productType === ProductType.CreatorSuite;
    const shouldSeeUpsellingBanner = isSubscriptionAntiSpam && (isCreatorProduct ? !isStandardPlan : !IsPro);

    return {
        ViewSubscriptionAntiSpamFeature: isSubscriptionAntiSpam || false,
        ViewAntiSpamUpsellingBanner: shouldSeeUpsellingBanner || false,
    };
};
